import { c as _c } from "react/compiler-runtime";
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Hint } from '@systemeio/ui';
import CourseActions from 'modules/courses/bundles/course-bundle/components/course-actions';
import { CourseBundleInterface, CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import { nonDraggableProps } from 'modules/courses/courses/curriculum/utils/non-draggable-props';
import { getCourseCurriculumUrl } from 'modules/courses/courses/utils/get-course-curriculum-url';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
interface CourseProps {
  item: CourseBundleItemInterface;
  mutate: KeyedMutator<CourseBundleInterface>;
}
const animateLayoutChanges: AnimateLayoutChanges = args => defaultAnimateLayoutChanges({
  ...args,
  wasDragging: true
});
function Course(t0) {
  const $ = _c(36);
  const {
    item,
    mutate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== item.id) {
    t1 = {
      id: item.id,
      animateLayoutChanges
    };
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transition,
    transform
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 0.5 : undefined;
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== transition) {
    t4 = {
      transition,
      transform: t2,
      opacity: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = transition;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const style = t4;
  let t5;
  if ($[8] !== style) {
    t5 = {
      ...style
    };
    $[8] = style;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== item.course.id) {
    t6 = getCourseCurriculumUrl({
      courseId: item.course.id
    });
    $[10] = item.course.id;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== item.course.name || $[13] !== t6) {
    t7 = <div className="text-text-primary text-start flex-[65_1_0%] truncate px-4 py-2 text-base lg:px-6 lg:py-4"><div className="relative flex h-full w-full max-w-fit cursor-pointer items-center gap-2 truncate text-base" {...nonDraggableProps}><LinkWithoutPrefetch className="primary-link w-full truncate" href={t6}>{item.course.name}</LinkWithoutPrefetch></div></div>;
    $[12] = item.course.name;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dashboard.course_bundle.course.delay_title_tooltip");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("dashboard.course_bundle.course.delay_title");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = item.delayBeforeStart || 0;
  let t11;
  if ($[19] !== t10 || $[20] !== t8 || $[21] !== t9) {
    t11 = <div className="text-text-primary text-start flex-[25_1_0%] truncate px-4 py-2 text-base lg:px-6 lg:py-4"><div><div className="relative flex h-full w-full max-w-fit items-center truncate" {...nonDraggableProps}><span className="cursor-default truncate"><Hint label={t8}>{t9} {t10}</Hint></span></div></div></div>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== item || $[24] !== mutate) {
    t12 = <div className="text-text-primary font-inter flex-[10_1_0%] truncate px-4 py-2 text-[17px] font-bold lg:px-6 lg:py-4"><CourseActions item={item} mutate={mutate} /></div>;
    $[23] = item;
    $[24] = mutate;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t7) {
    t13 = <div className="z-0 overflow-hidden rounded-lg"><div className="flex flex-col overflow-hidden rounded-b-lg lg:flex-row lg:items-center">{t7}{t11}{t12}</div></div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== attributes || $[31] !== listeners || $[32] !== setNodeRef || $[33] !== t13 || $[34] !== t5) {
    t14 = <div className="hover:border-brand-primary main-transition-colors bg-background-secondary mt-5 flex cursor-move flex-col gap-3 rounded-lg border border-transparent first:mt-0 focus-visible:outline-hidden" ref={setNodeRef} style={t5} {...attributes} {...listeners}>{t13}</div>;
    $[30] = attributes;
    $[31] = listeners;
    $[32] = setNodeRef;
    $[33] = t13;
    $[34] = t5;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
export default Course;